/**
 * @vuelto-surface
 * mobile: omit
 * desktop: ok
 * strategy: web-first
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { colors } from '../../../shared/theme/colors'
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography';
import {
  LOGIN_VALUE_BULLETS,
  LOGIN_VALUE_FOOTER,
  LOGIN_VALUE_SUB,
  LOGIN_VALUE_TITLE,
} from './loginMarketingCopy';

/**
 * Panel izquierdo del login wide — espejo del proto C
 * (`login-enrichment-options-v1.html` split-brand).
 */
export function LoginValuePanel() {
  return (
    <View
      style={styles.root}
      accessibilityRole="text"
      accessibilityLabel={`${LOGIN_VALUE_TITLE}. ${LOGIN_VALUE_SUB}. ${LOGIN_VALUE_FOOTER}`}
      testID="auth.login-value-panel"
    >
      {/* Faux gradient (sin LinearGradient): capas brand 700 → 500 → 600 */}
      <View style={styles.gradTop} pointerEvents="none" />
      <View style={styles.gradBottom} pointerEvents="none" />
      <View style={styles.top}>
        <View style={styles.brandRow}>
          <View style={styles.markBox} accessibilityElementsHidden>
            <Text style={styles.markLetter}>V</Text>
          </View>
          <Text style={styles.wordmark}>Vuelto</Text>
        </View>
        <Text style={styles.title}>{LOGIN_VALUE_TITLE}</Text>
        <Text style={styles.sub}>{LOGIN_VALUE_SUB}</Text>
        <View style={styles.bullets}>
          {LOGIN_VALUE_BULLETS.map((line) => (
            <View key={line} style={styles.bulletRow}>
              <View style={styles.bulletIcon} accessible={false}>
                <Text style={styles.bulletIconText}>·</Text>
              </View>
              <Text style={styles.bulletText}>{line}</Text>
            </View>
          ))}
        </View>
      </View>
      <Text style={styles.footer}>{LOGIN_VALUE_FOOTER}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1.05,
    minWidth: 300,
    backgroundColor: colors.accent,
    paddingVertical: 36,
    paddingHorizontal: 32,
    justifyContent: 'space-between',
    gap: spacing.xl,
    overflow: 'hidden',
    position: 'relative',
  },
  gradTop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '42%',
    backgroundColor: colors.accentStrong,
    opacity: 0.55,
  },
  gradBottom: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '38%',
    backgroundColor: colors.accentMuted,
    opacity: 0.55,
  },
  top: {
    gap: 10,
    zIndex: 1,
  },
  brandRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 8,
  },
  markBox: {
    width: 36,
    height: 36,
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  markLetter: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '800',
  },
  wordmark: {
    fontSize: 18,
    fontWeight: '800',
    letterSpacing: -0.3,
    color: '#FFFFFF',
  },
  title: {
    ...typography.titleXL,
    fontSize: 28,
    lineHeight: 34,
    letterSpacing: -0.8,
    color: '#FFFFFF',
    fontWeight: '800',
    marginTop: 12,
  },
  sub: {
    ...typography.body,
    fontSize: 15,
    lineHeight: 22,
    color: 'rgba(255,255,255,0.9)',
  },
  bullets: {
    marginTop: 24,
    gap: 12,
  },
  bulletRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
  },
  bulletIcon: {
    width: 22,
    height: 22,
    borderRadius: 6,
    backgroundColor: 'rgba(255,255,255,0.18)',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 1,
  },
  bulletIconText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 14,
  },
  bulletText: {
    flex: 1,
    fontSize: 14,
    lineHeight: 19,
    color: 'rgba(255,255,255,0.95)',
    fontWeight: '500',
  },
  footer: {
    fontSize: 14,
    lineHeight: 20,
    color: 'rgba(255,255,255,0.8)',
    fontWeight: '500',
    zIndex: 1,
  },
});
